import { render, staticRenderFns } from "./NumberFormItem.vue?vue&type=template&id=7c9ba5ca&"
import script from "./NumberFormItem.vue?vue&type=script&lang=js&"
export * from "./NumberFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../BougeMaVille-reborn-client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports